// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { amzSdkInvocationIdHeaderMiddlewareFactory, amzSdkRequestHeaderMiddlewareFactory, retryMiddlewareFactory, } from '../../middleware/retry';
import { userAgentMiddlewareFactory, } from '../../middleware/userAgent';
import { composeTransferHandler } from '../../internal/composeTransferHandler';
import { fetchTransferHandler } from '../fetch';
export const unauthenticatedHandler = composeTransferHandler(fetchTransferHandler, [
    userAgentMiddlewareFactory,
    amzSdkInvocationIdHeaderMiddlewareFactory,
    retryMiddlewareFactory,
    amzSdkRequestHeaderMiddlewareFactory,
]);
